/* Reads the host's own tokens: the --tl-* wall tokens where a wall card mounts it, else the product's
 * --text/--border/--yolk set. The --auth-* hooks are the ones MagicLinkForm already offers. */
.form {
  width: 100%;
  max-width: 360px;
  margin-top: 4px;
  text-align: start;
}

.label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.85rem;
  line-height: 1.4;
  color: var(--tl-muted, var(--text-muted));
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.input {
  flex: 1 1 140px;
  min-width: 0;
  padding: 10px 14px;
  border-radius: var(--radius-sm, 6px);
  border: 1px solid var(--auth-input-border, var(--tl-border-strong, var(--border)));
  background: var(--auth-input-bg, var(--tl-stage, var(--surface)));
  color: var(--tl-text, var(--text));
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 1.05rem;
  letter-spacing: 0.18em;

  &::placeholder {
    color: var(--tl-dim, var(--text-dim));
    letter-spacing: 0.18em;
  }

  &:focus-visible {
    outline: 2px solid var(--tl-accent, var(--yolk));
    outline-offset: 2px;
  }
}

.button {
  padding: 10px 18px;
  border-radius: var(--radius-sm, 6px);
  border: 1px solid var(--auth-input-border, var(--tl-border-strong, var(--border)));
  background: transparent;
  color: var(--tl-text, var(--text));
  font-family: var(--font-body, inherit);
  font-size: var(--auth-control-size, 0.9375rem);
  font-weight: var(--auth-control-weight, 500);
  white-space: nowrap;
  cursor: pointer;

  &:hover:not(:disabled) {
    border-color: var(--tl-accent, var(--yolk));
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.error {
  margin: 6px 0 0;
  font-size: 0.85rem;
  color: var(--error, var(--tl-error, #c0504d));
}
